/* eslint-disable */
import type { SVGProps } from 'react';
import { memo } from 'react';

const HH = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="480"
    width="800"
    viewBox="0 0 5 3"
    {...props}
  >
    <desc>Civil flag of North Rhine-Westphalia</desc>
    <rect
      height="2"
      width="5"
      fill="#FFF"
    />
    <rect
      height="1"
      width="5"
      fill="#009136"
    />
    <rect
      height="1"
      width="5"
      y="2"
      fill="#e3001b"
    />
  </svg>
);
export default memo(HH);
